import { IReportsSuccessfulSelector } from './../../../models/reports';
import { createSelector, createFeatureSelector, Selector } from '@ngrx/store';
import { ReportsState } from 'src/app/store/reports/reducers/reports.reducer';
import { IAppState } from 'src/app/store/state/app.state';

const getReportsState = createFeatureSelector<ReportsState>('reports');

export const getReportLoadingSelector = createSelector(getReportsState, (state: ReportsState) => state.loading);
export const getReportSuccessfulSelector: Selector<ReportsState, IReportsSuccessfulSelector> = createSelector(getReportsState, (state: ReportsState) => {
        return {
            isReportSuccessful: state.isReportSuccessful,
            reportSuccessfulText: state.reportSuccessfulText
        };
});
